import { Box, Grid } from '@mui/material'
import { useTranslations } from 'next-intl'
interface BoxStatusOrder {
  id: string
  data: any
  email?: string
}
export const BoxInfoOrderer = ({ id, data, email }: BoxStatusOrder) => {
  const t = useTranslations('UserProfile')
  return (
    <>
      <Box
        sx={{
          borderRadius: 3,
          border: '1px solid',
          borderColor: '#e0e0e0',
          p: 2,
        }}
      >
        <Box
          sx={{
            gap: 1,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Grid container spacing={2} columns={24}>
            <Grid size={{ xs: 8 }}>
              <Box sx={{ fontWeight: 300, fontSize: 14 }}>{t('Tên người đặt')}:</Box>
            </Grid>
            <Grid size={{ xs: 16 }}>
              <Box sx={{ fontWeight: 600, fontSize: 14 }}>{data?.lastname}</Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} columns={24}>
            <Grid size={{ xs: 8 }}>
              <Box sx={{ fontWeight: 300, fontSize: 14 }}>{t('Số điện thoại')}:</Box>
            </Grid>
            <Grid size={{ xs: 16 }}>
              <Box sx={{ fontWeight: 600, fontSize: 14 }}>{data?.telephone || '-'}</Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} columns={24}>
            <Grid size={{ xs: 8 }}>
              <Box sx={{ fontWeight: 300, fontSize: 14 }}>{t('Email')}:</Box>
            </Grid>
            <Grid size={{ xs: 16 }}>
              <Box sx={{ fontWeight: 600, fontSize: 14 }}>{email || data?.email || '-'}</Box>
            </Grid>
          </Grid>
          <Grid container spacing={2} columns={24}>
            <Grid size={{ xs: 8 }}>
              <Box sx={{ fontWeight: 300, fontSize: 14 }}>{t('Địa chỉ')}:</Box>
            </Grid>
            <Grid size={{ xs: 16 }}>
              <Box sx={{ fontWeight: 600, fontSize: 14 }}>
                {data?.street}, {data?.ward}, {data?.district}, {data?.city}{' '}
                {data?.country_code ? `, ${data?.country_code}` : ''}
              </Box>
            </Grid>
          </Grid>
          {data?.customer_notes && (
            <Grid container spacing={2} columns={24}>
              <Grid size={{ xs: 8 }}>
                <Box sx={{ fontWeight: 300, fontSize: 14 }}>{t('Ghi chú')}:</Box>
              </Grid>
              <Grid size={{ xs: 16 }}>
                <Box sx={{ fontWeight: 600, fontSize: 14 }}>{data?.customer_notes}</Box>
              </Grid>
            </Grid>
          )}
        </Box>
      </Box>
    </>
  )
}
